"use client"
import React from 'react';
// components
import Card from './Card';

interface CardGridContainerProps {
    data: any;
}

const CardGridContainer = (props: CardGridContainerProps) => {
    const { data } = props;
    return (
        <div className="container mx-auto pt-[32px] pb-[60px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center">
            {data.map((item: any, index: number) => (
                <Card key={index} data={item} />
            ))}
        </div>
    )
}

export default CardGridContainer;